export default "__VITE_ASSET__ClIr1Lsg__"